"use client";

import useCurrency from "@/lib/helpers/hooks/useCurrency.ts";
import * as S from "./styles.ts";
import { useTypedSelector } from "@/redux/helpers/hooks.ts";
import { H4, Skeleton } from "@template/components";

type CardProps = {
  id: number;
};

const Card = ({ id }: CardProps) => {
  const prices = useTypedSelector((state) => state.store.tlds.prices.prices);

  const currency = useCurrency();
  const foundPrice = prices.find((price) => price.id === id);

  return (
    <S.CardContainer>
      <Skeleton hideSkeleton={!!foundPrice}>
        <H4>.{foundPrice?.name || "domain"}</H4>
      </Skeleton>
      <Skeleton hideSkeleton={!!foundPrice}>
        <S.Price>
          <S.Cost>
            {currency}
            {foundPrice?.cost["1-4"].net / 100 || "0.00"}
          </S.Cost>
          <span>/year</span>
        </S.Price>
      </Skeleton>
    </S.CardContainer>
  );
};

export default Card;
